var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"copy-list"},[_c('copy-list-item',{attrs:{"number":"01","title":"concept<br>big idea","texts":[
      'Myślimy turbo kreatywnie,<br>działamy szeroko, wyprzedzamy<br>trendy i&nbsp;wiemy, na&nbsp;czym polega<br>przygotowanie przemyślanej<br>BIG&nbsp;IDEA.',
      'Forma prezentacji ma dla nas<br>znaczenie.'
    ]}}),_vm._v(" "),_c('copy-list-item',{attrs:{"number":"02","title":"digitally<br>driven","texts":[
      'Jesteśmy świadomi<br>DIGITAL POWER i&nbsp;mamy wiedzę<br>analityczną, którą czerpiemy<br>od mocnego partnera strategicznego.',
      'Nasz hype to przemyślana<br>kreacja x&nbsp;liczby.'
    ]}}),_vm._v(" "),_c('copy-list-item',{attrs:{"number":"03","title":"execution","texts":[
      'Za każdym razem dobieramy<br>odpowiedni zespół ludzi<br>- zarówno ten kreatywny jak<br>i&nbsp;produkcyjny. Polegamy<br>na&nbsp;silnym zespole wewnątrz organizacji oraz współpracujemy<br>z&nbsp;doświadczonymi<br>podwykonawcami.'
    ]}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ceaefba","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyList.vue
// module id = null
// module chunks = 